import React from "react";
import classnames from "classnames";

import "./index.scss";

export interface CheckboxProps extends React.HTMLProps<HTMLInputElement> {
  inputRef?: React.RefObject<HTMLInputElement>;
}

const Checkbox: React.FC<CheckboxProps> = (props) => {
  const { inputRef, className, ...inputProps } = props;

  return (
    // The disabled state is a MODIFIER CLASS, not `:has(.checkbox-input:disabled)`. The real input is
    // visually hidden, so the only styleable target is this container -- but `:has()` needs Chrome 105+
    // / Firefox 121+, and this project's production browserslist (">0.2%, not dead") still resolves to
    // Chrome 103 and Firefox 117. There, `:has()` silently matches nothing and a disabled checkbox
    // renders identically to an enabled one, which is the exact bug this state exists to fix.
    <label
      className={classnames("checkbox-input-container", className, {
        "checkbox-input-container--disabled": inputProps.disabled,
      })}
    >
      <input ref={inputRef} className="checkbox-input" type="checkbox" {...inputProps} />
      <div className="checkbox-input-inner" />
    </label>
  );
};

export default Checkbox;
